'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var AlertSnackBar = require('../snackbars/AlertSnackBar/AlertSnackBar.js');
require('../snackbars/BottomCenterSnackbar/BottomCenterSnackbar.js');
var rpcErrorHandler = require('../utils/rpcErrorHandler.js');
var styledComponents = require('./styled-components.js');
var useNotification = require('../hooks/useNotification.js');

var Notification = function () {
    var _a = useNotification(), notification = _a.notification, removeNotification = _a.removeNotification;
    var onClose = function () {
        removeNotification();
    };
    var fm = reactIntl.useIntl().formatMessage;
    if (notification) {
        var prefix = notification.prefix, messages = notification.messages, _b = notification.severity, severity = _b === void 0 ? 'error' : _b;
        // eslint-disable-next-line no-console
        var logger = severity === 'error' ? console.error : undefined;
        var extractedMessages = rpcErrorHandler.getMessages(messages, fm, logger).map(function (message) { return React__default.createElement(styledComponents.Detail, { key: message }, message); });
        return (React__default.createElement(AlertSnackBar, { severity: severity, onClose: onClose },
            React__default.createElement("div", null,
                prefix && React__default.createElement(styledComponents.Prefix, null, prefix),
                extractedMessages)));
    }
    return React__default.createElement(React__default.Fragment, null);
};

module.exports = Notification;
